import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { HealthResponseSchema } from '../schemas/health.js';

export const health = {
  check: endpoint('GET', '/health', z.object({}), HealthResponseSchema),
};
